<template>
  <div>
    <div
      class="button-setting"
      :class="data.position && 'button-more-setting'"
      :style="{
        position: data.position,
        bottom: (btnBottom ) / 16 + 'rem',
        'margin-bottom': (data.marginBottom ) / 16 + 'rem',
        fontSize: (data.fontSize ) / 16 + 'rem',
        fontWeight: data.fontWeight,
        color: data.btnFontColor,
        textAlign: data.textAlign,
        fontFamily: data.family,
        width: (data.btnWidth ) / 16 + 'rem',
        height: (data.btnHeight ) / 16 + 'rem',
        borderRadius: (data.btnRadius ) / 16 + 'rem',
        lineHeight: (data.btnHeight ) / 16 + 'rem',
        'background-color': data.btnColor,
        'background-image': 'url(' + data.btnImage + ')'
      }"
      @click="handleClick(data.btnEventStatus)"
    >
      <img v-if="data.btnIcon" :src="data.btnIcon" class="btnIcon">
      <span class="btnText"> {{ data.btnText }}</span>
    </div>
    <div v-if="isIphoneX && data.position && data.bottomIphoneX" :style="{
      position: data.position,
      bottom: 0,
      width: (data.btnWidth ) / 16 + 'rem',
      height: (data.bottomIphoneX ) / 16 + 'rem',
      'background-color': data.btnColor,
    }"></div>
  </div>
</template>

<script>
import { isIphoneX, sensorsBuriedPoint, getUrlParam } from '../common/util';
import clientUtil from '../common/clientUtil';
import { post } from '../common/http';
import createMessage from './Toast/index.js'
import { getIosVersion, isIOS } from '../common/util'
export default {
  name: "Button",
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      isIphoneX: isIphoneX()
    };
  },
  computed: {
    btnBottom() {
      return this.isIphoneX ? this.data.bottomIphoneX || this.data.bottom : this.data.bottom
    }
  },
  methods: {
    handleClick() {
      let btnEventType = this.data.btnEventStatus;
      switch (btnEventType) {
        // 跳转链接
        case 'jumpLinkH5': {
          window.location.href = this.data.linkH5;
          break;
        }
        case 'jumpLinkClient': {
          clientUtil.openNewWebPage({
            pageUrl: this.data.linkClient,
          })
          break;
        }
        case 'btnEvent': {
          if (this.data.btnEvent === '在线客服') {
            post('/api/getLineUrl').then(res => {
              if (res.data) {
                const { custom_field_2, externalId, NAME } = res.data;
                location.href = `https://u-weicai12345.dezhuyun.com/vHelp?token=namYnyF3EbIn&showChat=true&layout=true&externalId=${encodeURIComponent(externalId)}&custom_field_2=${encodeURIComponent(custom_field_2)}&NAME=${encodeURIComponent(NAME)}`;
              }
            })
            return
          }
          if (this.data.btnEvent === '复制去微信') {
            this.copy();
            sensorsBuriedPoint("WxActivitySubmit", {
              Source: getUrlParam("from") || ""
            });
            const data = {
              path: 'pages/wx-web-view/index'
            }
            clientUtil.getHeaders((headers) => {
              data['YX-IMEI'] = headers['YX-IMEI']
            })
            post('/api/getWechatUrl', data).then(() => {
              this.copy()
              // 微信小程序处理
              // if(res && res.data) {
                // const { openlink } = res.data || {};
                // if(openlink) {
                //   createMessage({
                //     text: '正在打开微信请稍后',
                //     timeout: 2000
                //   })
                //   setTimeout(() => {
                //     window.location.href = openlink
                //   }, 2000)
                // } else {
                //   this.copy()
                // }
              // }
            }).catch(()=>{
              this.copy()
            }).finally(() => {
              // 低于13的ios版本复制功能有问题，进行兼容
              const versionList = getIosVersion()
              const gtIos13 = versionList[0] >= 13
              createMessage({
                  text: isIOS() && !gtIos13 ? '因您的手机系统太低，请手动在微信里搜索公众号 好分期服务号' : '已为您复制"好分期服务号"，正在跳转微信',
                  timeout: 2000
                })
              setTimeout(()=> {
                window.location.href = "weixin://"
              }, 2000)
            })
          }
          break;
        }
      }
    },
    copy() {
      var aux = document.createElement("input"); 
      aux.setAttribute("value", "好分期服务号"); 
      document.body.appendChild(aux); 
      aux.select();
      document.execCommand("copy"); 
      document.body.removeChild(aux);
    }
  }
};
</script>

<style lang="less" scoped>
.button-setting {
  overflow: hidden;
  border-radius: 5px;
  padding: 0 10px;
  word-break: break-all;
  white-space: pre-line;
  background-size: 100% 100%;
  background-position: center;
  z-index: 1;
  .btnIcon {
    width: 24px;
    height: 24px;
    vertical-align: middle;
    font-weight: inherit;
  }
  .btnText {
    font-weight: inherit;
  }
}
.button-more-setting {
  left: 50%;
  transform: translateX(-50%);
}
</style>
